import {
  Paper,
  Table,
  TableBody,
  TableHead,
  Typography,
} from '@material-ui/core'
import { t } from 'i18next'
import React from 'react'
import { getEmissionCoefficient } from '../../../emission-coefficients/emission-coefficient-calculator'
import {
  COEFFICIENT_CHECKPOINT_YEARS,
  EmissionModel,
} from '../../../emission-coefficients/emission-coefficients'
import { PurchasedEnergyType } from '../../../generated/graphql'
import { emissionPerEnergyUnit } from '../../../util/formatters'
import { Section } from '../../common/Section'
import { SidebarAccordionTableRow } from '../../common/SidebarAccordionTableRow'

import CoefficientsSidebarTable from '../CoefficientsSidebarTable'
import { useReportStyles } from '../use-report-styles'

type Props = {
  emissionModel: EmissionModel
}

export default function CoefficientsReportTable({
  emissionModel,
}: Props): React.ReactElement {
  const classes = useReportStyles()

  const coefficientsByEnergyType = Object.values(PurchasedEnergyType).map(
    (energyType) => ({
      energyType,
      coefficients: [
        emissionModel.buildingYear,
        ...COEFFICIENT_CHECKPOINT_YEARS,
      ].map((year) => ({
        year,
        value: getEmissionCoefficient(energyType, year),
      })),
    }),
  )

  return (
    <>
      <Section title={t('common.basicInfo')} printPadding>
        <Paper className={`${classes.paper} ${classes.margin}`} elevation={3}>
          <Table>
            <TableHead>
              <SidebarAccordionTableRow
                name={
                  <Typography variant="subtitle1">
                    {t('carbonFootprint.basicInfo.title')}
                  </Typography>
                }
                value={<div />}
                showBorder
                printPadding
              />
            </TableHead>
            <TableBody>
              <SidebarAccordionTableRow
                name={t('carbonFootprint.basicInfo.buildingYear')}
                value={emissionModel.buildingYear}
                printPadding
              />
              <SidebarAccordionTableRow
                name={t('carbonFootprint.basicInfo.inspectionLengthInYears')}
                value={emissionModel.inspectionLengthInYears}
                printPadding
              />
            </TableBody>
          </Table>
        </Paper>
      </Section>
      <Section
        title={t('carbonFootprint.emissionCoefficients')}
        subtitle={emissionPerEnergyUnit}
        printPadding
      >
        <Paper className={`${classes.paper} ${classes.margin}`}>
          {coefficientsByEnergyType.map((coefficients) => (
            <CoefficientsSidebarTable
              key={coefficients.energyType}
              coefficientsByEnergyType={coefficients}
              printPadding
            />
          ))}
        </Paper>
      </Section>
    </>
  )
}
